import { NotificationItem } from './notification-item';
import { pdsI18n } from '../pds-i18n';

export type AssignmentTemplateNotificationItemContext = {
  postedAt: Date,
  assignmentTemplateUid: string,
  assignmentName: string,
  sectionUid: string,
  sectionName?: string,
  hasBeenAssigned: boolean,
  needsReassignment: boolean,
  assignmentUid?: string
};

export class AssignmentTemplateNotificationItem extends NotificationItem {
  static NOTIFICATION_TYPE = 'ASSIGNMENT_NOTIFICATION';
  static NOTIFICATION_SUBTYPE = 'ASSIGNMENT_TEMPLATE_NOTIFICATION';

  static generateLookUpKey(context: AssignmentTemplateNotificationItemContext): string {
    return [context.assignmentTemplateUid, context.sectionUid, AssignmentTemplateNotificationItem.NOTIFICATION_TYPE].join(',');
  }

  constructor(
    private context: AssignmentTemplateNotificationItemContext
  ) {
    super(AssignmentTemplateNotificationItem.NOTIFICATION_TYPE, false, (context.hasBeenAssigned && !context.needsReassignment), undefined, AssignmentTemplateNotificationItem.NOTIFICATION_SUBTYPE);

    this.isMarkedReadOnClick = false; // for assignment template messages the feature itself is in charge of marking things read

    this.aggregationKey = JSON.stringify({
      assignmentTemplateUid: this.context.assignmentTemplateUid,
      sectionUid: this.context.sectionUid,
      assignmentUid: this.context.assignmentUid
    });
  }

  getTitle(): string {
    return this.context.assignmentName;
  }

  getSubtitle(): string {
    return this.context.sectionName || '';
  }

  getPostedAt(): Date | null {
    return new Date(this.context.postedAt);
  }

  getTooltip(): string {
    return pdsI18n.getText('pds|notifications|Messages regarding xx', { name: this.context.assignmentName });
  }

  getRequiresAction(): boolean {
    return !this.context.hasBeenAssigned || this.context.needsReassignment;
  }

  get lookUpKey(): string {
    return AssignmentTemplateNotificationItem.generateLookUpKey(this.context);
  }
}
